import { Modal, Row, Col, Button, Form } from 'react-bootstrap'

import styles from './styles.module.css'
import { useState } from 'react'
import api from '../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../utils/errorApi'
import { useLoading } from '../../hooks/LoadingContext'

function ChangePasswordModal({ show, closeModal, id, role = '' }) {
  const { isLoading, setIsLoading } = useLoading()
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPassword_confirmation, setNewPassword_confirmation] = useState('')

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsLoading(true)

    if (newPassword !== newPassword_confirmation) {
      toast.info('As senhas não coincidem')
      setIsLoading(false)
      return
    }

    try {
      if (role === 'admin') {
        await api.put(`/admin/users/${id}/password`, {
          password: newPassword,
        })
      } else {
        await api.put(`/users/${id}/password`, {
          oldPassword,
          newPassword,
          newPassword_confirmation,
        })
      }

      setOldPassword('')
      setNewPassword('')
      setNewPassword_confirmation('')
      toast.success('Senha alterada com sucesso!')
      closeModal()
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao atualizar a senha! Verifique os dados.'))
    }
    setIsLoading(false)
  }

  const isValidModel = () => {
    return oldPassword && newPassword && newPassword_confirmation
  }

  return (
    <Modal centered show={show} onHide={closeModal}>
      <Modal.Header closeButton />
      <Modal.Body>
        <h4 style={{ textAlign: 'center' }}>Alterar senha</h4>
        <Row
          style={{
            padding: 12,
            textAlign: 'left',
          }}
        >
          <Form.Label className={styles.label}>Senha atual*</Form.Label>
          <Form.Control
            className={styles.input}
            type="password"
            placeholder="Digite a senha atual"
            value={oldPassword}
            onChange={(event) => setOldPassword(event.target.value)}
          />
        </Row>
        <Row
          style={{
            padding: 12,
            textAlign: 'left',
          }}
        >
          <Form.Label className={styles.label}>Nova senha*</Form.Label>
          <Form.Control
            className={styles.input}
            type="password"
            placeholder="Digite a senha"
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
          />
        </Row>
        <Row
          style={{
            padding: 12,
            textAlign: 'left',
          }}
        >
          <Form.Label className={styles.label}>Repita a senha*</Form.Label>
          <Form.Control
            className={styles.input}
            type="password"
            placeholder="Digite a senha"
            value={newPassword_confirmation}
            onChange={(event) => setNewPassword_confirmation(event.target.value)}
          />
        </Row>
        <Row style={{ padding: 4, paddingBottom: 4 }}>
          <Col style={{ padding: 8, paddingBottom: 4 }}>
            <Button className={`${styles.btnn} ${styles.btnnNo}`} onClick={closeModal}>
              Cancelar
            </Button>
          </Col>
          <Col style={{ padding: 8, paddingBottom: 4 }}>
            <Button
              className={`${styles.btnn} ${styles.btnnYes}`}
              disabled={isLoading || !isValidModel()}
              onClick={handleSubmit}
            >
              Alterar senha
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default ChangePasswordModal
